"use strict";

exports.__esModule = true;
exports.AdvancedRealTimeMetricChartElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _Time = require("../../Time");
var _API = require("../../API");
var _dataConverter = require("./dataConverter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedRealTimeMetricChartElement = exports.AdvancedRealTimeMetricChartElement = function AdvancedRealTimeMetricChartElement(props) {
  var children = props.children,
    selectedDevices = props.selectedDevices,
    metricNames = props.metricNames;
  var timePeriod = (0, _Time.useSelectionContext)();
  var reportingPeriod = timePeriod && timePeriod.name === "shift" ? "shift" : "workday";
  var getMetricChannels = function getMetricChannels() {
    return selectedDevices.reduce(function (acc, device) {
      metricNames.forEach(function (metricName) {
        acc[device.uuid + ":" + metricName] = ["metric", {
          entity: {
            device: device.uuid,
            name: metricName,
            period: reportingPeriod,
            aggregateBy: "PT1H"
          }
        }];
      });
      return acc;
    }, {});
  };
  return /*#__PURE__*/_react["default"].createElement(_API.RealtimeBatchSubscription, {
    channels: getMetricChannels()
  }, function (results) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "AdvancedRealTimeMetricChartElement.chart"
    }, children((0, _dataConverter.convertRealTimeDataToEchartsFormat)(results, true, timePeriod.interval.endMillis)));
  });
};